import Marquee from "react-fast-marquee";
import { audiences } from "@/config/content";
import { useReducedMotion } from "framer-motion";

export const AudienceStrip = () => {
  const reduce = useReducedMotion();
  const items = [...audiences, ...audiences, ...audiences];
  return (
    <section aria-label="Für wen wir arbeiten" className="bg-forest py-5 border-y border-forest-dark" data-testid="audience-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {reduce ? (
          <ul className="flex flex-wrap justify-center gap-x-10 gap-y-3">
            {audiences.map((a) => (
              <li key={a.label} className="inline-flex items-center gap-2.5 text-white/85 font-medium">
                <a.icon className="w-5 h-5 text-gold" strokeWidth={1.75} /> {a.label}
              </li>
            ))}
          </ul>
        ) : (
          <Marquee speed={28} gradient gradientColor="#1B4332" gradientWidth={80} pauseOnHover>
            {items.map((a, i) => (
              <span key={i} className="inline-flex items-center gap-2.5 text-white/85 font-medium mx-8">
                <a.icon className="w-5 h-5 text-gold" strokeWidth={1.75} /> {a.label}
                <span className="ml-8 text-white/25">/</span>
              </span>
            ))}
          </Marquee>
        )}
      </div>
    </section>
  );
};
